var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VideoInModal',_vm._b({attrs:{"ratio":2 / 3,"small-overlay":""}},'VideoInModal',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }